<div class="component-main-container">
  <!-- container do mapa -->
  <app-page-header>
  </app-page-header>
  <div class="full" id="map" #map></div>

</div>

<!-- Barra de instalações selecionadas -->
@if (selectedInstallationsView) {
  <app-painel-fav [options]="selectedInstallations"
  [selectedOption]="selectedOptions"></app-painel-fav>
}

<!-- Wheel p/ seleção -->
@if (wheelView) {
  <div class="wheel">
    <div class="arc" style="--i:1;">
      <div class="svg"></div>
    </div>
    <div class="arc" style="--i:2;" title="{{ 'map.wheel-command-label' | translate }}"
      (click)="commandSelectInstallation()">
      <div class="svg"></div>
    </div>
    <div class="arc" style="--i:3;" title="{{ 'map.wheel-report-label' | translate }}"
      (click)="reportSelectInstallation()">
      <div class="svg"></div>
    </div>
    <div class="arc" style="--i:4;" title="{{ 'map.wheel-installationList-label' | translate }}"
      (click)="selectInstallation()">
      <div class="svg"></div>
    </div>
    <!-- Redireciona para a tela de logs -->
    <div class="arc" style="--i:5;" title="Logs" (click)="logsSelectInstallation()">
      <div class="svg"></div>
    </div>
    <div class="arc" style="--i:6;" (click)="sendCommandsByPolygon(installationMacAddress, 'on')">
      <div class="svg"></div>
    </div>
    <div class="arc" style="--i:7;" (click)="sendCommandsByPolygon(installationMacAddress, 'off')">
      <div class="svg"></div>
    </div>
    <div class="arc" style="--i:8;">
      <div class="svg"></div>
    </div>
  </div>
}

@if (!filterController && (lastQuery != 'is_active=true' || filterForm.get('status')?.value != null)) {
  <button title="{{ 'map.download-csv-label' | translate}}" class="btn btn-success downloadCSV"
    (click)="downloadCSV()">
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-cloud-arrow-down-fill"
      viewBox="0 0 16 16">
      <path
        d="M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2m2.354 6.854-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 9.293V5.5a.5.5 0 0 1 1 0v3.793l1.146-1.147a.5.5 0 0 1 .708.708z" />
      </svg>
    </button>
  }

  <!-- Botão para alternar o tema do mapa entre modo claro e modo escuro -->
  <button (click)="changeMapTheme()" class="btn btn-success view" id="modeDark">
    <mat-icon class="component-svg-icon" svgIcon="bx-theme"></mat-icon>
  </button>

  <button (click)="openDemonstrationMode()" class="btn btn-success view" id="demoMode">
    <mat-icon class="component-svg-icon" svgIcon="bx-play"></mat-icon>
  </button>


  <!-- Botão p/ filtro -->
  @if (!filterController) {
    <button title="{{ 'map.filter-label' | translate}}" class="btn btn-success search"
      (click)="openSidebarEdit()"><mat-icon svgIcon="bx-search-white"
    style="font-size: 0px; margin-top: 5px;"></mat-icon></button>
  }

  <!-- Sidebar de filtro -->
  @if (filterController) {
    <div class="sidebar-edit" [formGroup]="filterForm">
      <div class="info-icon">
        <app-helper></app-helper>
      </div>
      <mat-icon (click)="closeEditionSideBar()">clear</mat-icon>
      <h2> {{ 'map.filter-label' | translate}} </h2>
      <hr>
        @if (lastQuery != 'is_active=true') {
          <p class="select-filter" (click)="selectLastQuery()">{{
          'map.select-last-filter' | translate }}</p>
        }
        <mat-tab-group mat-stretch-tabs="true" mat-align-tabs="center">
          <!-- filtro por elementos -->
          <mat-tab label="{{ 'map.filter-fields' | translate}}">
            <hr>
              <mat-form-field appearance="outline">
                <mat-label> {{ 'map.reference-label' | translate}} </mat-label>
                <input matInput formControlName="reference">
              </mat-form-field>
              @if (hasCircuitBox) {
                <mat-form-field appearance="outline">
                  <mat-label> {{'map.circuit-box-label' | translate}}</mat-label>
                  <input matInput formControlName="circuitBox">
                </mat-form-field>
              }
              <mat-form-field appearance="outline">
                <mat-label>{{'map.serial-number-label' | translate}} </mat-label>
                <input matInput formControlName="serialNumber">
              </mat-form-field>
              <!-------------------------------- Input do filtro por status(temporareamente removido)------------------------------- -->
              <mat-form-field appearance="outline">
                <mat-label> {{ 'map.status-label' | translate}} </mat-label>
                <mat-select formControlName="status">
                  <mat-option apperance="outline" [value]="null">
                    {{ 'map.none' | translate}}
                  </mat-option>
                  <mat-option apperance="outline" [value]="'on'">
                    {{ 'map.on' | translate}}
                  </mat-option>
                  <mat-option apperance="outline" [value]="'off'">
                    {{ 'map.off' | translate}}
                  </mat-option>
                  <mat-option apperance="outline" [value]="'6hours'">
                    {{ 'map.6h-no-transmission' | translate}}
                  </mat-option>
                  <mat-option apperance="outline" [value]="'24hours'">
                    {{ 'map.24h-no-transmission' | translate}}
                  </mat-option>
                  <mat-option apperance="outline" [value]="'never'">
                    {{ 'map.never-transmitted' | translate}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label> {{ 'map.magnetic-key' | translate}} </mat-label>
                <mat-select formControlName="magneticKey">
                  <mat-option apperance="outline" [value]="null">
                    {{ 'map.none' | translate}}
                  </mat-option>
                  <mat-option apperance="outline" [value]="true">
                    {{ 'map.maybe' | translate}}
                  </mat-option>
                  <mat-option apperance="outline" [value]="false">
                    {{ 'map.it-has-not' | translate}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label> {{ 'map.subdivision' | translate }} </mat-label>
                <mat-select multiple formControlName="division">
                  @if (!allDivisions.length) {
                    <mat-option disabled>{{ 'map.no-subdivision' | translate
                    }}</mat-option>
                  }
                  @for (division of allDivisions; track division) {
                    <mat-option apperance="outline" [value]="division.id">
                      {{division.reference}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label> {{ 'map.gateway' | translate }} </mat-label>
                <mat-select multiple formControlName="gateway" panelClass="gateway-select-panel">
                  <mat-form-field [style.width.%]="100" appearance="outline">
                    <mat-label>Filtrar</mat-label>
                    <input matInput #searchGateways class="input-filter" focused="true"
                      (keyup)="filterGateways(searchGateways.value)" (keydown)="$event.stopPropagation()">
                    </mat-form-field>
                    @if (!allGateways.length) {
                      <mat-option disabled>{{ 'map.no-gateway' | translate }}</mat-option>
                    }
                    @for (gateway of filteredGateways; track gateway) {
                      <mat-option apperance="outline"
                      [value]="gateway.id">{{gateway.reference}}</mat-option>
                    }
                </mat-select>
                </mat-form-field>
                @if(filterForm.get('gateway')?.value?.length) {
                  <div class="border border-success rounded mb-2">
                    <div class="d-flex align-items-center">
                      <mat-label class="text-success m-2"> {{'map.search-origin' | translate}} </mat-label>
                      <mat-icon class="text-primary origin-info-icon"
                      aria-label="Information"
                      title="* Comunicação: instalações que se comunicaram com o concentrador.&#013;* Cadastro: instalações associadas ao concentrador no sistema." 
                      >
                      info_outline
                      </mat-icon>
                    </div>
                    <mat-radio-group formControlName="gatewaySearchOrigin" class="d-flex flex-column my-2">
                      <mat-radio-button value="communication">{{'map.communication-route' | translate}}</mat-radio-button>
                      <mat-radio-button value="registration">{{'map.registration-route' | translate}}</mat-radio-button>
                    </mat-radio-group>
                  </div>
                }
                <div class="buttons">
                  @if (!filterLoading) {
                    <button class="btn btn-success filter" (click)="filterByElements()">{{
                    'map.filter-label' | translate }}</button>
                  }
                  @if (!filterLoading) {
                    <button class="btn btn-secondary filter" (click)="resetGateways()">{{
                    'map.reset-label' | translate }}</button>
                  }
                </div>
                @if (filterLoading) {
                  <div class="spinner">
                    <div class="custom-loader"></div>
                    @if (markers.length > 0 && totalInstallations > 0) {
                      <p>{{ ((markers.length / totalInstallations) *
                      100).toFixed(0) }}%</p>
                    }
                    @if (markers.length === 0 && totalInstallations >= 0) {
                      <p>0%</p>
                    }
                  </div>
                }
              </mat-tab>
              <!-- filtro por formas -->
              <mat-tab label="{{ 'map.area-label' | translate }}">
                <hr>
                  <br>
                    <mat-slide-toggle class="example-margin" color="accent" [formControl]="polygonSlideToggle"
                      (change)="openPolygon()">
                      {{ 'map.polygon' | translate }}
                    </mat-slide-toggle>
                    <br><br>
                    <hr>
                      <br>
                        <div class="addres-label">
                          <mat-label>Endereço</mat-label>
                        </div>
                        <br>
                          <mat-form-field appearance="outline">
                            <mat-label> {{ 'map.street' | translate }} </mat-label>
                            <input matInput formControlName="street">
                          </mat-form-field>
                          <mat-form-field appearance="outline">
                            <mat-label> {{ 'map.district' | translate }} </mat-label>
                            <input matInput formControlName="district">
                          </mat-form-field>
                          <mat-form-field appearance="outline">
                            <mat-label> Latitude </mat-label>
                            <input matInput formControlName="latitude">
                          </mat-form-field>
                          <mat-form-field appearance="outline">
                            <mat-label> Longitude </mat-label>
                            <input matInput formControlName="longitude">
                            <mat-hint align="start"><strong>Informe os campos de latitude e longitude
                            </strong> </mat-hint>
                          </mat-form-field>
                          <br>
                            @if (!filterFormsLoading) {
                              <button class="btn btn-success filter" id="btn-filter" (click)="filterBypolygons()">{{
                              'map.filter-label' | translate }} </button>
                            }
                            @if (filterFormsLoading) {
                              <div class="spinner">
                                <div class="custom-loader"></div>
                                @if (markers.length > 0 && totalInstallations > 0) {
                                  <p>{{ ((markers.length / totalInstallations) *
                                  100).toFixed(0) }}%</p>
                                }
                                @if (markers.length === 0 && totalInstallations >= 0) {
                                  <p>0%</p>
                                }
                              </div>
                            }
                          </mat-tab>
                          <!-- favoritos -->
                          @if (favoriteList?.favorites) {
                            <mat-tab label="{{ 'map.favorites-label' | translate }}">
                              <hr>
                                @if (!viewFavorite) {
                                  <div>
                                    @if (favoriteList?.favorites[companyId!]) {
                                      <div class="table">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td><strong>{{ 'map.reference-label' | translate }}</strong></td>
                                              <td></td>
                                              <td><strong>{{ 'map.actions-label' | translate }}</strong></td>
                                              <td></td>
                                            </tr>
                                            @for (favorite of favoriteList?.favorites[companyId!]; track favorite; let index = $index) {
                                              <tr>
                                                <td>{{ favorite.reference }}</td>
                                                <td> <img title="{{ 'map.filter-label' | translate }}" src="../../../../assets/imgs/search.svg"
                                                alt="search" (click)="filterByFavorite(favorite)"> </td>
                                                <td> <img title="{{ 'map.view-label' | translate }}" src="../../../../assets/imgs/eye.svg" alt="view"
                                                (click)="viewOnFavorite(favorite)"> </td>
                                                <td> <img title="{{ 'map.trash-label' | translate }}" src="../../../../assets/imgs/trash.svg"
                                                alt="trash" (click)="removeFavorite(index)"> </td>
                                              </tr>
                                            }
                                          </tbody>
                                        </table>
                                      </div>
                                    }
                                  </div>
                                }
                                @if (viewFavorite) {
                                  <div>
                                    <mat-form-field appearance="outline">
                                      <mat-label> {{ 'map.installations-label' | translate }} </mat-label>
                                      <mat-select>
                                        @for (installation of favoriteSelected.installations; track installation) {
                                          <mat-option apperance="outline" [value]="null" disabled
                                            >
                                            {{ installation.reference }}
                                          </mat-option>
                                        }
                                      </mat-select>
                                    </mat-form-field>
                                    <img class="arrow-back" src="../../../../assets/imgs/arrow_back.svg" alt="arrow_back"
                                      (click)="viewOffFavorite()">
                                    </div>
                                  }
                                  @if (!favoriteList?.favorites[companyId!]) {
                                    <p class="no-favorites">{{ 'map.there-is-no-favorites' |
                                    translate }}</p>
                                  }
                                </mat-tab>
                              }
                            </mat-tab-group>
                          </div>
                        }

                        <!-- Sidebar de mais informações -->
                        @if (moreInfoController) {
                          <div class="sidebar-edit">
                            <mat-icon (click)="closeMoreInformation()">clear</mat-icon>
                            <mat-button-toggle-group [(ngModel)]="choiceOptionsToView">
                              <!-- Detalhes -->
                              <mat-button-toggle value="details">{{ 'map.details-label' | translate }}</mat-button-toggle>
                              <!-- Alertas -->
                              <mat-button-toggle value="alerts">{{ 'map.alerts-label' | translate }}</mat-button-toggle>
                              <!-- comandos -->
                              <mat-button-toggle value="commands">{{ 'map.commands-label' | translate }}</mat-button-toggle>
                            </mat-button-toggle-group>
                            @if (choiceOptionsToView === 'details') {
                              <div class="details">
                                <div class="table">
                                  <table>
                                    <tbody>
                                      <tr>
                                        <td><strong>{{ 'map.serial-number-label' | translate }}</strong></td>
                                        <td>{{ serialNumber }} @if (detailConsuptionLoading) {
                                          <mat-spinner [diameter]="20"></mat-spinner>
                                        }</td>
                                      </tr>
                                      <tr>
                                        <td><strong>{{ 'map.address-label' | translate }}</strong></td>
                                        <td>{{ address }} @if (detailConsuptionLoading) {
                                          <mat-spinner [diameter]="20"></mat-spinner>
                                        }
                                      </td>
                                    </tr>
                                    <tr>
                                      <td><strong>{{ 'map.gateway-label' | translate }}</strong></td>
                                      <td>{{ gateway }}</td>
                                    </tr>
                                    <tr>
                                      <td><strong>{{ 'map.lat-label' | translate }}</strong></td>
                                      <td>{{ lat }}</td>
                                    </tr>
                                    <tr>
                                      <td><strong>{{ 'map.long-label' | translate }}</strong></td>
                                      <td>{{ long }}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          }
                          <!-- Alertas -->
                          @if (choiceOptionsToView === 'alerts') {
                            <div class="alerts">
                              <div class="table">
                                <table>
                                  <thead>
                                    <tr>
                                      <th>{{ 'map.reference-label' | translate }}</th>
                                      <th>{{ 'map.date-label' | translate }}</th>
                                      <th>{{ 'map.status-label' | translate }}</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    @for (alert of alerts; track alert) {
                                      <tr>
                                        <td><strong>{{alert.reference}}</strong></td>
                                        <td matTooltip="{{ 'time-zone-information-label' | translate }}" matTooltipPosition="above">
                                          {{
                                        alert.timestamp }}</td>
                                        <td>{{ alert.status }}</td>
                                      </tr>
                                    }
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          }
                          <!-- Comandos -->
                          @if (choiceOptionsToView === 'commands') {
                            <div class="commands">
                              <div class="table">
                                <table>
                                  <thead>
                                    <tr>
                                      <th>{{ 'map-command.request-date-label' | translate }}</th>
                                      <th>{{ 'map-command.command-type-label' | translate }}</th>
                                      <th>{{ 'map-command.sent-by-label' | translate }}</th>
                                      <th>{{ 'map-command.status-command-label' | translate }}</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    @for (command of commands; track command) {
                                      <tr>
                                        <td>
                                          {{ command.timestamp | date: 'dd/MM/yyyy HH:mm:ss' }}
                                        </td>
                                        <td><strong>{{ command.type}}</strong></td>
                                        <td>{{ command.userName }}</td>
                                        <td>
                                          @if (command.details.node.status === 'SUCCESS') {
                                            <p>
                                              {{ "map-command.success" | translate }}
                                            </p>
                                          }
                                          @if (command.details.node.status === 'QUEUED') {
                                            <p>
                                              {{ "map-command.queued" | translate }}
                                            </p>
                                          }
                                          @if (command.details.node.status === 'DEV_ERR') {
                                            <p>
                                              {{ "map-command.error" | translate }}
                                            </p>
                                          }
                                          @if (command.details.node.status === 'INVALID') {
                                            <p>
                                              {{ "map-command.invalid" | translate }}
                                            </p>
                                          }
                                        </td>
                                      </tr>
                                    }
                                  </tbody>
                                </table>
                              </div>
                              <div class="text-center mt-3">
                                @if (hasPreviousPageCommands) {
                                  <button class="btn btn-link text-success d-inline-flex align-items-center justify-content-center"
                                    (click)="getCommmandsBulkRequestsMacAddress(getselectedMarker())">
                                    @if (!isLoadingInstallationFilter) {
                                      <span>
                                        {{ 'map-command.load-more-commands' | translate }}
                                      </span>
                                    }
                                    @if (isLoadingInstallationFilter) {
                                      <mat-spinner [diameter]="20">
                                      </mat-spinner>
                                    }
                                  </button>
                                }
                              </div>
                            </div>
                          }
                        </div>
                      }

                      <!--  sidebar de consultar comandos -->
                      @if (queryCommands) {
                        <div class="sidebar-edit">
                          <mat-icon (click)="closeQueryCommands()">clear</mat-icon>
                          <h2>{{ 'map-command.queryCommand' | translate }}</h2>
                          <br>
                            <div class="container">
                              <div class="row command-form d-flex flex-column">
                                <section class="col consult d-flex flex-column">
                                  <mat-radio-group [(ngModel)]="consultValue">
                                    <mat-radio-button class="d-block  my-2" value="STATUS">{{
                                      "commands.consult-status" | translate
                                    }}</mat-radio-button>
                                    <mat-radio-button class="d-block  my-2" value="DIAGNOSTIC">{{
                                      "commands.consult-diagnostic" | translate
                                    }}</mat-radio-button>
                                    <mat-radio-button class="d-block  my-2" value="PARAMETERS">{{
                                      "commands.consult-parameters" | translate
                                    }}</mat-radio-button>
                                    <mat-radio-button class="d-block  my-2" value="MEASUREMENT">{{
                                      "commands.commands-measurement" | translate
                                    }}</mat-radio-button>
                                    <mat-radio-button class="d-block  my-2" value="LATEST_MEASUREMENT">{{
                                      "commands.consult-last-measurement" | translate
                                    }}</mat-radio-button>
                                    <mat-radio-button class="d-block  my-2" value="VERSION">{{
                                      "commands.consult-version" | translate
                                    }}</mat-radio-button>
                                    <mat-radio-button class="d-block  my-2" value="GET_SCHEDULE">{{
                                      "commands.consult-get-schedule" | translate
                                    }}</mat-radio-button>
                                  </mat-radio-group>
                                  <!-- botao  de enviar comando -->
                                  @if (!isLoadingInstallationFilter) {
                                    <button title="Enviar" (click)="consultationQuery()"
                                      class="btn btn-success m-0 w-100">
                                      {{ "map-command.sendCommand" | translate }}
                                    </button>
                                  }
                                  @if (isLoadingInstallationFilter) {
                                    <div class="d-flex justify-content-center w-100 my-2">
                                      <mat-spinner [diameter]="30"></mat-spinner>
                                    </div>
                                  }
                                </section>
                              </div>
                            </div>
                          </div>
                        }

                        <!-- Sidebar de mais informações -->
                        @if (demonstrationController && !isRunning) {
                          <div class="sidebar-edit sidebar-demonstration">
                            <mat-icon (click)="closeDemonstrationMode()">clear</mat-icon>
                            <h2>{{ 'map.demonstration-mode' | translate }}</h2>
                            <br>
                              <mat-form-field appearance="outline" [formGroup]="demonstrationForm">
                                <mat-label> {{ 'map.filter-delay' | translate }} <strong>[Min 5]</strong></mat-label>
                                <input type="number" matInput min="5" formControlName="delay">
                              </mat-form-field>
                              <div class="buttons">
                                @if (!isRunning) {
                                  <button class="btn btn-success filter" [disabled]="!demonstrationForm.valid"
                                    (click)="startDemonstration()"> {{
                                  'map.start-demonstration' | translate }} </button>
                                }
                              </div>
                            </div>
                          }

                          @if (demonstrationController && isRunning) {
                            <div class="sidebar-running">
                              <mat-icon (click)="closeDemonstrationMode()">clear</mat-icon>
                              <div class="gateway-info">
                                <label>{{ 'map.gateway-reference' | translate }}</label>
                                <h2>{{ gatewayName }}</h2>
                              </div>
                              @if (elementIsFound) {
                                <div class="table">
                                  <table>
                                    <tbody>
                                      <tr>
                                        <td><strong>{{ 'map.serial-number-label' | translate }}</strong></td>
                                        <td>{{ selectedGateway.serialNumber }}</td>
                                      </tr>
                                      <tr>
                                        <td><strong>{{ 'map.cpu-usage' | translate }}</strong></td>
                                        <td>{{ selectedGateway.cpuPercent }}%</td>
                                      </tr>
                                      <tr>
                                        <td><strong>{{ 'map.current-temperature' | translate }}</strong></td>
                                        <td>{{ selectedGateway.temperatureCurrent }}Cº</td>
                                      </tr>
                                      <tr>
                                        <td><strong>{{ 'map.last-reboot' | translate }}</strong></td>
                                        <td>{{ selectedGateway.lastReboot }}</td>
                                      </tr>
                                      <tr>
                                        <td><strong>{{ 'map.disk-usage' | translate }}</strong></td>
                                        <td>{{ selectedGateway.diskPercent }}%</td>
                                      </tr>
                                      <tr>
                                        <td><strong>{{ 'map.equipment-count' | translate }}</strong></td>
                                        <td><label>{{ equipmentCount }}</label>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            }
                            @if (isRunning) {
                              <button class="btn btn-secondary" (click)="stopDemonstration()"> {{
                                'map.stop-demonstration' | translate }}
                              </button>
                            }
                          </div>
                        }